module.exports = __webpack_public_path__ + "static/media/KNI_2026_Logo.1bc238a2.png";